export let config = {
  loop: true,
  autoplay: true,
  interval: 10000, // значение по умолчанию
  swipe: true, // разрешает листать слайды свайпом и перемещением курсора мыши при зажатой левой кнопки мыши;
  refresh: false // обновляет слайдер при изменении размеров окна браузера, но только в том случае если изменяется количество отображаемых элементов.
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/config.js